import { isSameDay } from "date-fns";
import { es } from "date-fns/locale";
import { toZonedTime, formatInTimeZone } from "date-fns-tz";

export const getDailyAssessmentLabel = (date) => {
  const timeZone = "America/Bogota";

  const mow = toZonedTime(new Date(), timeZone);
  const targetInBogota = toZonedTime(new Date(date), timeZone);

  if (isSameDay(mow, targetInBogota)) {
    return "Consultas de hoy";
  } else {
    const formatted = formatInTimeZone(
      targetInBogota,
      timeZone,
      "dd 'de' MMMM 'de' yyyy",
      {
        locale: es,
      }
    );
    return `Consultas del ${formatted}`;
  }
};
